import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import AWS from "aws-sdk";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/AppContext";
import { addAsset } from "../../service/Asset";
import { FaArrowLeft } from "react-icons/fa";
import { RiUploadCloud2Line } from "react-icons/ri";
import translations from "../../components/common/Translations";
import { uploadFileToS3 } from "../../service/S3Bucket";
import CommonButton from "../../components/common/CommonButton";

const AddAsset = () => {
  const [AssertType, setAssertType] = useState("Honeywell_Mobile");
  const [AssertName, setAssertName] = useState("");
  const [AssertBarcode, setAssertBarcode] = useState("");
  const [Description, setDescription] = useState("");
  const [photoUrl, setPhotoUrl] = useState(null);
  const [documentUrl, setDocumentUrl] = useState(null);
  const { theme, selectedOrgId, langMode, setOpenTab } = useContext(AppContext);
  const [selectedPhotoFile, setSelectedPhotoFile] = useState(null);
  const [selectedDocumentFile, setSelectedDocumentFile] = useState(null);

  const navigate = useNavigate();
  const handleSelectChange = (event) => {
    setAssertType(event.target.value);
  };
  const handleAssertNameChange = (event) => {
    setAssertName(event.target.value);
  };
  const handleAssertBarcodeChange = (event) => {
    setAssertBarcode(event.target.value);
  };
  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleFileUpload = async (file, targetType) => {
    if (!file) {
      toast.error("No file selected.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size exceeds 5MB.");
      return;
    }
    const fileType = getFileType(file, targetType);
    if (!fileType) {
      return; // Don't proceed if the file type is invalid
    }
    if (targetType === "image") {
      setSelectedPhotoFile(file);
    } else {
      setSelectedDocumentFile(file);
    }
  };

  const getFileType = (file, targetType) => {
    const imageTypes = ["image/jpeg", "image/png", "image/gif", "image/bmp"];
    const documentTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
    ];

    if (targetType === "image") {
      if (imageTypes.includes(file.type)) {
        return "image";
      } else {
        toast.error("Invalid file type. Please upload an image.");
        return null;
      }
    }

    if (targetType === "document") {
      if (documentTypes.includes(file.type)) {
        return "document";
      } else {
        toast.error("Invalid file type. Please upload a document.");
        return null;
      }
    }

    // Handle unexpected file types
    toast.error("Unsupported file type.");
    return null;
  };


  // Preview the selected file
  React.useEffect(() => {
    if (selectedPhotoFile) {
      const reader = new FileReader();
      reader.onloadend = () => setPhotoUrl(reader.result);
      reader.readAsDataURL(selectedPhotoFile);
    } else {
      setPhotoUrl(null);
    }
  }, [selectedPhotoFile]);

  React.useEffect(() => {
    if (selectedDocumentFile) {
      setDocumentUrl(selectedDocumentFile.name); // Set the document name for preview
    } else {
      setDocumentUrl(null);
    }
  }, [selectedDocumentFile]);


  const handleAddAssert = async () => {
    // console.log("Current Document URL:", documentUrl);
    // console.log("Current Photo URL:", photoUrl);

    let photoUrl = null;
    let documentUrl = null;

    // Upload files to S3
    try {
      if (selectedPhotoFile) {
        photoUrl = await uploadFileToS3(selectedPhotoFile, "image");
      }
      if (selectedDocumentFile) {
        documentUrl = await uploadFileToS3(selectedDocumentFile, "document");
      }
    } catch (error) {
      console.error("File upload failed:", error);
      toast.error("Failed to upload files.");
      return;
    }

    if (
      !AssertType ||
      !AssertName ||
      !AssertBarcode
    ) {
      toast.error("Please fill all fields before adding asset");
      return;
    }
    const formData = {
      assertType: AssertType,
      assertName: AssertName,
      assertBarcode: AssertBarcode,
      assertImg: photoUrl,
      description: Description,
      assertDoc: documentUrl,
      organizationId: selectedOrgId,
    };
    try {
      const data = await addAsset(formData);
      if (data.header.code === 600) {
        toast.success("Asset Added Successfully");
        navigate("/asset");
        setOpenTab(2);
        setAssertType("");
        setAssertName("");
        setDescription("");
        setDocumentUrl(null);
        setPhotoUrl(null);
        setAssertBarcode("");
        return data;
      }
      else if (data.header.code === 601) {
        toast.error(data.body.value);
      }
    } catch (error) {
      console.error("Failed to add asset:", error);
    }
  };

  const handleCancel = () => {
    setAssertType("");
    setAssertName("");
    setDescription("");
    setDocumentUrl(null);
    setPhotoUrl(null);
    setAssertBarcode("");
  };
  const handleGoBack = () => {
    navigate("/asset");
    setOpenTab(2)
  };
  return (
    <>
      <div className="flex"> <div
        onClick={handleGoBack}
        className={`p-2   rounded-full border cursor-pointer w-8 m-3 
       ${theme === "dark" ? "bg-gray-800 border-gray-600 hover:bg-gray-700" : ""
          } 
       ${theme === "high-contrast"
            ? "high-contrast border border-gray-600"
            : ""
          } 
       ${theme !== "dark" && theme !== "high-contrast"
            ? "border-gray-400 hover:bg-gray-200"
            : ""
          }`}
      >
        <FaArrowLeft
          className={`h-3 w-3 ${theme === "dark"
            ? "text-white"
            : theme === "high-contrast"
              ? "text-black"
              : "text-gray-700"
            }`}
        />
      </div>
        <h4 className={`mt-4 text-sm uppercase font-semibold text-gray-800 ${theme === "dark"
          ? "dark-mode  "
          : theme === "high-contrast"
            ? "high-contrast  "
            : ""
          }`}>
          {translations[langMode].addnewasset}
        </h4></div>
      <div className="w-full">

        <div
          className={`px-5  bg-white ${theme === "dark"
            ? "dark-mode  "
            : theme === "high-contrast"
              ? "high-contrast  "
              : ""
            }`}
        >
          <div className="w-1/2">
            <div className="mt-3 grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-4">
              <div className="sm:col-span-2">
                <div className="relative">
                  <select
                    id="vehical_dropdown"
                    value={AssertType}
                    onChange={handleSelectChange}
                    className={`block required: px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      }`} >
                    <option value="Honeywell_Mobile">Honeywell_Mobile</option>
                    <option value="Electric_Meter">Electric_Meter</option>
                    <option value="Water_Meter">Water_Meter</option>
                  </select>
                  <label
                    htmlFor="vehical_dropdown"
                    className={`${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      } absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-6 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark"
                        ? "dark-mode  "
                        : theme === "high-contrast"
                          ? "high-contrast  "
                          : ""
                      }`}
                  >
                    {translations[langMode].assetType}
                  </label>
                </div>
              </div>
              <div className="sm:col-span-2">
                <div className="relative">
                  <input
                    type="text"
                    id="name"
                    value={AssertName}
                    onChange={handleAssertNameChange}
                    className={` ${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      } block required: px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer`}
                  />
                  <label
                    className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                  peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4  ${theme === "dark"
                        ? "dark-mode  "
                        : theme === "high-contrast"
                          ? "high-contrast  "
                          : ""
                      }`}
                  >
                    {translations[langMode].AssetName}
                  </label>
                </div>
              </div>

              <div className="sm:col-span-2">
                <div className="relative">
                  <input
                    type="text"
                    id="AssertName"
                    value={AssertBarcode}
                    onChange={handleAssertBarcodeChange}
                    className={`${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      } block required: px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer`}
                  />
                  <label
                    className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                  peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark"
                        ? "dark-mode  "
                        : theme === "high-contrast"
                          ? "high-contrast  "
                          : ""
                      }`}
                  >
                    {translations[langMode].assetBarCode}
                  </label>
                </div>
              </div>


            </div>
            <div className="mt-3 grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-4">

              <div className="sm:col-span-2 ">
                {photoUrl ? (
                  <div className="sm:col-span-2 ">
                    <div className="px-5 py-3 border border-gray-600 rounded-md bg-gray-100">
                      <h5 className="text-xs">Uploaded Image</h5>
                      <img
                        src={photoUrl}
                        alt="Uploaded preview"
                        className="w-32 h-28 object-cover rounded-md"
                      />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e.target.files[0], "image")}
                      className={`block w-full text-sm text-gray-900 bg-transparent border-2 rounded-md ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""}`}
                    />
                  </div>
                ) : (
                  <div className="flex items-center justify-center py-2 w-full sm:col-span-2 border border-gray-600 rounded-md bg-gray-100">
                    <label
                      htmlFor="dropzone-file"
                      className="flex flex-col items-center justify-center w-full h-54 rounded-lg cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                    >
                      <div className="flex flex-row items-center justify-center gap-4 p-2 pt-5 pb-6">
                        <RiUploadCloud2Line className="w-10 h-10" />
                        <div className="flex flex-col items-center">
                          <p className="mb-2 text-sm text-gray-600 dark:text-gray-400">
                            <span className="font-semibold">Drag and drop Photos</span>
                          </p>
                          <p className="text-sm text-gray-500 dark:text-gray-400">
                            {translations[langMode].maxFileSize5MB}
                          </p>
                          <p className="text-sm text-blue-700 font-semibold underline dark:text-gray-400">
                            {translations[langMode].browse}
                          </p>
                        </div>
                      </div>
                      <input
                        id="dropzone-file"
                        type="file"
                        className="hidden"
                        onChange={(e) => handleFileUpload(e.target.files[0], "image")}
                      />
                    </label>
                  </div>
                )}
              </div>

              <div className="sm:col-span-2 ">
                {documentUrl ? (
                  <div className="sm:col-span-2 ">
                    <div className=" border border-gray-600 rounded-md bg-gray-100">
                      <h5 className="text-xs text-black mx-3">{translations[langMode].uploadedDocument}:</h5>
                      <div className="my-14">
                        <a
                          href={documentUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white rounded-md my-14 mx-20 py-4 px-2 text-xs text-nowrap  bg-blue-800"
                        >
                          {translations[langMode].viewDocuments}
                        </a>
                      </div>
                    </div>

                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.txt"
                      onChange={(e) => handleFileUpload(e.target.files[0], "document")}
                      className={`block w-full text-sm text-gray-900 bg-transparent border-2  rounded-md ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""}`}
                    />
                  </div>
                ) : (
                  <div className="flex items-center justify-center py-2 w-full sm:col-span-2 border border-gray-600 rounded-md bg-gray-100">
                    <label
                      htmlFor="dropzone-file"
                      className="flex flex-col items-center justify-center w-full h-54 rounded-lg cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                    >
                      <div className="flex flex-row items-center justify-center gap-4 p-2 pt-5 pb-6">
                        <RiUploadCloud2Line className="w-10 h-10" />
                        <div className="flex flex-col items-center">
                          <p className="mb-2 text-sm text-gray-600 dark:text-gray-400">
                            <span className="font-semibold">{translations[langMode].dragAndDropDocuments}</span>
                          </p>
                          <p className="text-sm text-gray-500 dark:text-gray-400">
                            {translations[langMode].maxFileSize5MB}
                          </p>
                          <p className="text-sm text-blue-700 font-semibold underline dark:text-gray-400">
                            {translations[langMode].browse}
                          </p>
                        </div>
                      </div>
                      <input
                        id="dropzone-file"
                        type="file"
                        className="hidden"
                        onChange={(e) => handleFileUpload(e.target.files[0], "document")}
                      />
                    </label>
                  </div>
                )}
              </div>

              <div className="sm:col-span-2">
                <textarea
                  id="message"
                  rows="4"
                  value={Description}
                  onChange={handleDescriptionChange}
                  className="block p-2.5 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder={translations[langMode].description}
                ></textarea>
              </div>
            </div>
          </div>
          <div className="">
            <div className="sm:col-span-4">
              <hr className="w-full border-gray-300" />
            </div>
            <div className="sm:col-span-4 py-3 flex justify-end items-center gap-3">
              {/* <button
                type="button"
                onClick={handleCancel}
                className="px-3 py-2 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
              >
                {translations[langMode].cancle}
              </button> */}

              <CommonButton onClick={handleCancel} variant="danger">
                {translations[langMode].cancle}
              </CommonButton>

              {/* <button
                type="button"
                onClick={handleAddAssert}
                className="px-3 py-2 text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                {translations[langMode].submit}
              </button> */}

              <CommonButton onClick={handleAddAssert} variant="primary">
                {translations[langMode].submit}
              </CommonButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAsset;
